import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import {
  IconError03,
  IconError01,
  IconError02,
  IconRefresh03,
  IconArrowRight01,
  LogoWcon04,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** type */
  type?: '500' | '404' | 'network' | 'service-check' | 'filter' | string;
  /** title */
  title?: string;
  /** detail */
  detail?: string;
  /** detail2 */
  detail2?: string;
  /** linkText */
  linkText?: string;
  /** info */
  info?: { estmtTime: string; serviceCenter: string };
  /** logo */
  logo?: boolean;
  /** className */
  className?: string;
  /** onClick */
  onClick?: () => void;
}

const ErrorCont = ({
  type = '500',
  title = '',
  detail = '',
  detail2 = '',
  info,
  linkText,
  logo = false,
  className,
  onClick,
}: IProps) => {
  const cl = classNameBind([
    'error-cont',
    type ? `type-${type}` : '',
    className || '',
  ]);

  // ITEM RENDERER : getType
  const getType = () => {
    if (type === '500' || type === '404') {
      return <IconError02 />;
    }
    if (type === 'network') {
      return <IconError01 />;
    }
    if (type === 'service-check') {
      return <IconError03 />;
    }
    return null;
  };

  const str = (txt: React.ReactNode) => String(txt);

  return (
    <S.ErrorCont className={cl}>
      {type !== 'filter' && <div className="icon">{getType()}</div>}
      {title && (
        <div
          className="title"
          dangerouslySetInnerHTML={{ __html: str(title) }}
        />
      )}
      {detail && (
        <div
          className="detail"
          dangerouslySetInnerHTML={{ __html: str(detail) }}
        />
      )}
      {info && (
        <dl className="info">
          {info.estmtTime && (
            <>
              <dt>점검시간</dt>
              <dd dangerouslySetInnerHTML={{ __html: str(info.estmtTime) }} />
            </>
          )}
          {info.serviceCenter && (
            <>
              <dt>고객센터</dt>
              <dd>
                <Button href={`mailto:${info.serviceCenter}`}>
                  {info.serviceCenter}
                </Button>
              </dd>
            </>
          )}
        </dl>
      )}
      {detail2 && (
        <div
          className="detail"
          dangerouslySetInnerHTML={{ __html: str(detail2) }}
        />
      )}
      {linkText && (
        <Button
          className="btn-link"
          onClick={onClick}
          icon={
            type === 'network' ||
            type === 'service-check' ||
            type === '500' ||
            type === 'filter' ? (
              <IconRefresh03 />
            ) : (
              <IconArrowRight01 />
            )
          }
        >
          {linkText}
        </Button>
      )}
      {logo && (
        <Button href="/" className="btn-logo">
          <LogoWcon04 />
        </Button>
      )}
    </S.ErrorCont>
  );
};

export default ErrorCont;
